module.exports = __webpack_public_path__ + "static/media/thingstodo.196024cd.png";